<template>
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="false"
        filename="startup.pdf"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        :paginate-elements-by-height="1400"
        :html-to-pdf-options="{
            margin: 5,
            html2canvas: {
                useCORS: true,
                scrollY: 0,
            },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy']},
            image: {
                type: 'jpeg',
                quality: 0.5
            }
        }"
        @beforeDownload="download"
        ref="html2Pdf"
    >

        <section slot="pdf-content" class="pdf-version">

            <div v-for="(startup, index) in startups" :key="index">

                <div class="header">
                    <div class="header__navigation">
                        <div href="/" class="" title="Switch Pitch">
                            <svg width="176px" height="34px" viewBox="0 0 178 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <defs>
                                    <linearGradient x1="34.087839%" y1="81.0746617%" x2="100%" y2="81.0746617%" id="linearGradient-1">
                                        <stop stop-color="#FFFFFF" offset="0%"></stop>
                                        <stop stop-color="#00AFEF" offset="100%"></stop>
                                    </linearGradient>
                                </defs>
                                <g id="Logo" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="Group">
                                        <path d="M7.93333333,32 C9.36444444,32 10.6111111,31.7967914 11.6733333,31.3903743 C12.7355556,30.9839572 13.5555556,30.3933824 14.1333333,29.6186497 C14.7111111,28.8439171 15,27.9188948 15,26.8435829 C15,25.3533868 14.4688889,24.1320187 13.4066667,23.1794786 C12.3444444,22.2269385 10.7244444,21.4331551 8.54666667,20.7981283 C7.25777778,20.4171123 6.30666667,20.029746 5.69333333,19.6360294 C5.08,19.2423128 4.77333333,18.7618093 4.77333333,18.1945187 C4.77333333,17.8135027 4.88666667,17.4684715 5.11333333,17.1594251 C5.34,16.8503788 5.67777778,16.6069519 6.12666667,16.4291444 C6.57555556,16.2513369 7.12,16.1624332 7.76,16.1624332 C8.76444444,16.1624332 9.52666667,16.3931595 10.0466667,16.8546123 C10.5666667,17.3160651 10.8266667,17.9362745 10.8266667,18.7152406 L10.8266667,18.7152406 L15,18.7152406 C15,17.5975936 14.7022222,16.6048351 14.1066667,15.7369652 C13.5111111,14.8690954 12.6711111,14.195967 11.5866667,13.7175802 C10.5022222,13.2391934 9.25333333,13 7.84,13 C6.43555556,13 5.18666667,13.2137923 4.09333333,13.641377 C3,14.0689617 2.14444444,14.6743538 1.52666667,15.4575535 C0.908888889,16.2407531 0.6,17.1446078 0.6,18.1691176 C0.6,19.1936275 0.884444444,20.0784314 1.45333333,20.8235294 C2.02222222,21.5686275 2.78,22.1888369 3.72666667,22.6841578 C4.67333333,23.1794786 5.80444444,23.6303476 7.12,24.0367647 C8.14222222,24.3500446 8.91555556,24.6421569 9.44,24.9131016 C9.96444444,25.1840463 10.3244444,25.4676916 10.52,25.7640374 C10.7155556,26.0603832 10.8133333,26.4286988 10.8133333,26.868984 C10.8133333,27.4616756 10.5711111,27.9400624 10.0866667,28.3041444 C9.60222222,28.6682264 8.88444444,28.8502674 7.93333333,28.8502674 C6.73333333,28.8502674 5.81111111,28.6153075 5.16666667,28.1453877 C4.52222222,27.6754679 4.2,26.9113191 4.2,25.8529412 L4.2,25.8529412 L0,25.8529412 C0,27.1991979 0.377777778,28.3358957 1.13333333,29.2630348 C1.88888889,30.1901738 2.86888889,30.8781194 4.07333333,31.3268717 C5.27777778,31.7756239 6.56444444,32 7.93333333,32 Z" id="Path" fill="#62D5FF" fill-rule="nonzero"></path>
                                        <polygon id="Path" fill="#62D5FF" fill-rule="nonzero" points="25.1320973 32 28 19.6552198 30.8806489 32 34.9339513 32 39 13 35.023175 13 32.626883 26.206044 29.6952491 13 26.3047509 13 23.3858633 26.206044 20.976825 13 17 13 21.0787949 32"></polygon>
                                        <path d="M46,13 L45.9999905,32 L42.0014951,32 L42,13.0059633 C42.5890103,13.3469077 43.2697105,13.5415285 43.9948664,13.5415285 C44.7242396,13.5415285 45.4086385,13.3446375 46,13 Z" id="Combined-Shape" fill="#62D5FF" fill-rule="nonzero"></path>
                                        <path d="M124,13 L123.999991,32 L120.001495,32 L120,13.0059633 C120.58901,13.3469077 121.269711,13.5415285 121.994866,13.5415285 C122.72424,13.5415285 123.408638,13.3446375 124,13 Z" id="Combined-Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
                                        <polygon id="Path" fill="#62D5FF" fill-rule="nonzero" points="57.4221106 32 57.4221106 16.3145604 63 16.3145604 63 13 48 13 48 16.3145604 53.4899497 16.3145604 53.4899497 32"></polygon>
                                        <path d="M73.593985,32 C75.0559733,32 76.3299916,31.7292363 77.4160401,31.1877088 C78.5020886,30.6461813 79.3479532,29.8888889 79.9536341,28.9158317 C80.559315,27.9427744 80.9039265,26.8216433 80.9874687,25.5524382 L80.9874687,25.5524382 L77.0651629,25.5524382 C76.9899749,26.6354932 76.6746032,27.4372077 76.1190476,27.9575818 C75.5634921,28.4779559 74.7218045,28.738143 73.593985,28.738143 C72.7251462,28.738143 72.0275689,28.5350701 71.5012531,28.1289245 C70.9749373,27.7227789 70.5906433,27.1072144 70.3483709,26.2822311 C70.1060986,25.4572478 69.9849624,24.3890002 69.9849624,23.0774883 L69.9849624,23.0774883 L69.9849624,21.9225117 C69.9849624,19.9763972 70.2815372,18.5464262 70.8746867,17.6325985 C71.4678363,16.7187709 72.3784461,16.261857 73.6065163,16.261857 C74.7844612,16.261857 75.63868,16.5347361 76.1691729,17.0804943 C76.6996658,17.6262525 77.0025063,18.4575818 77.0776942,19.5744823 L77.0776942,19.5744823 L81,19.5744823 C80.8830409,18.2798931 80.5300752,17.1397239 79.9411028,16.1539746 C79.3521303,15.1682253 78.5229741,14.3961256 77.4536341,13.8376754 C76.3842941,13.2792251 75.1019215,13 73.6065163,13 C72.0776942,13 70.7410192,13.3638388 69.5964912,14.0915164 C68.4519632,14.8191939 67.566416,15.8578268 66.9398496,17.2074148 C66.3132832,18.5570029 66,20.1371632 66,21.9478958 L66,21.9478958 L66,23.0774883 C66,24.8966823 66.3028404,26.4768426 66.9085213,27.8179693 C67.5142022,29.159096 68.3893066,30.1913828 69.5338346,30.9148297 C70.6783626,31.6382766 72.031746,32 73.593985,32 Z" id="Path" fill="#62D5FF" fill-rule="nonzero"></path>
                                        <polygon id="Path" fill="#62D5FF" fill-rule="nonzero" points="86.9447236 32 86.9447236 23.9354396 94.0678392 23.9354396 94.0678392 32 98 32 98 13 94.0678392 13 94.0678392 20.6339286 86.9447236 20.6339286 86.9447236 13 83 13 83 32"></polygon>
                                        <path d="M107.104217,31.746159 L107.104217,25.3239813 L110.476473,25.3239813 C111.957825,25.3239813 113.243116,25.0828323 114.332346,24.6005344 C115.421575,24.1182365 116.253747,23.4328657 116.82886,22.5444222 C117.403974,21.6559786 117.69153,20.6194611 117.69153,19.4348697 C117.69153,18.241817 117.401795,17.1799154 116.822325,16.249165 C116.242855,15.3184146 115.408505,14.5886217 114.319275,14.0597862 C113.230045,13.5309508 111.949111,13.2665331 110.476473,13.2665331 L110.476473,13.2665331 L103,13.2665331 L103,31.746159 L107.104217,31.746159 Z M110.476473,22.1002004 L107.104217,22.1002004 L107.104217,16.490314 L110.476473,16.490314 C111.164866,16.490314 111.739979,16.6256958 112.201812,16.8964596 C112.663646,17.1672233 113.003486,17.5268314 113.221331,17.9752839 C113.439177,18.4237364 113.5481,18.9187263 113.5481,19.4602538 C113.5481,20.2725451 113.295399,20.915609 112.789997,21.3894456 C112.284594,21.8632821 111.513419,22.1002004 110.476473,22.1002004 L110.476473,22.1002004 Z M136.892471,31.746159 L136.892471,16.490314 L142.695887,16.490314 L142.695887,13.2665331 L127.089404,13.2665331 L127.089404,16.490314 L132.801325,16.490314 L132.801325,31.746159 L136.892471,31.746159 Z M152.211398,32 C153.736319,32 155.06518,31.7292363 156.197978,31.1877088 C157.330777,30.6461813 158.213053,29.8888889 158.844807,28.9158317 C159.47656,27.9427744 159.836006,26.8216433 159.923144,25.5524382 L159.923144,25.5524382 L155.831997,25.5524382 C155.753573,26.6354932 155.424625,27.4372077 154.845155,27.9575818 C154.265685,28.4779559 153.387766,28.738143 152.211398,28.738143 C151.305159,28.738143 150.577553,28.5350701 150.028581,28.1289245 C149.47961,27.7227789 149.078773,27.1072144 148.826072,26.2822311 C148.573371,25.4572478 148.44702,24.3890002 148.44702,23.0774883 L148.44702,23.0774883 L148.44702,21.9225117 C148.44702,19.9763972 148.756361,18.5464262 149.375044,17.6325985 C149.993726,16.7187709 150.943534,16.261857 152.224468,16.261857 C153.45312,16.261857 154.344109,16.5347361 154.897438,17.0804943 C155.450767,17.6262525 155.766643,18.4575818 155.845068,19.5744823 L155.845068,19.5744823 L159.936215,19.5744823 C159.814221,18.2798931 159.446061,17.1397239 158.831736,16.1539746 C158.21741,15.1682253 157.352562,14.3961256 156.237191,13.8376754 C155.121819,13.2792251 153.784245,13 152.224468,13 C150.629836,13 149.235622,13.3638388 148.041826,14.0915164 C146.848031,14.8191939 145.924364,15.8578268 145.270826,17.2074148 C144.617288,18.5570029 144.290519,20.1371632 144.290519,21.9478958 L144.290519,21.9478958 L144.290519,23.0774883 C144.290519,24.8966823 144.606396,26.4768426 145.238149,27.8179693 C145.869902,29.159096 146.782677,30.1913828 147.976473,30.9148297 C149.170268,31.6382766 150.58191,32 152.211398,32 Z M166.497734,31.746159 L166.497734,23.9024716 L173.908853,23.9024716 L173.908853,31.746159 L178,31.746159 L178,13.2665331 L173.908853,13.2665331 L173.908853,20.6913828 L166.497734,20.6913828 L166.497734,13.2665331 L162.393517,13.2665331 L162.393517,31.746159 L166.497734,31.746159 Z" id="PITCH" fill="#FFFFFF" fill-rule="nonzero"></path>
                                        <g id="Group-2" transform="translate(41.000000, 0.000000)">
                                            <path d="M2.7522056,12.7903639 C4.27220678,12.7903639 5.5044112,11.4655125 5.5044112,9.83122553 C5.5044112,8.19693855 4.27220678,6.87208718 2.7522056,6.87208718 C1.23220442,6.87208718 0,8.19693855 0,9.83122553 C0,11.4655125 1.23220442,12.7903639 2.7522056,12.7903639 Z" id="Oval-Copy-2" fill="#FFFFFF"></path>
                                            <path d="M81.1565017,12.8469909 C82.6765029,12.8469909 83.9087073,11.5221395 83.9087073,9.88785254 C83.9087073,8.25356556 82.6765029,6.92871419 81.1565017,6.92871419 C79.6365005,6.92871419 78.4042961,8.25356556 78.4042961,9.88785254 C78.4042961,11.5221395 79.6365005,12.8469909 81.1565017,12.8469909 Z" id="Oval-Copy-2" fill="#62D5FF"></path>
                                            <path d="M43.2486455,0 C54.1926839,0 66.1003033,2.01713751 78.9715037,6.05141254 C77.8227245,6.8481076 77.0617568,8.23634455 77.0617568,9.81567844 L77.0650631,9.98640965 C65.0529015,4.24300856 53.7807623,1.37130802 43.2486455,1.37130802 C31.9156853,1.37130802 19.725884,4.69633018 6.67924163,11.3463745 C6.87404896,10.8297204 6.98120445,10.2639799 6.98120445,9.67133022 C6.98120445,8.49190763 6.55682224,7.41905743 5.86328479,6.6196778 L5.85892549,6.58339076 C19.3704546,2.19446359 31.8336946,0 43.2486455,0 Z" id="Combined-Shape" fill="url(#linearGradient-1)"></path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="main" v-if="typeof startup.commonData !== 'undefined'">
                    <div class="aside aside--details">
                        <div class="aside__inner">
                            <div class="image-block image-block--lg mt-0">
                                <img :src="getLogoUrl(baseURL + '/img/startup-logos/' + startup.commonData.logo_url)" alt="img"/>
                            </div>
                            <h2 class="heading2">{{startup.commonData.name}}</h2>

                            <div v-if="false" class="type-label">Buzzing</div>

                            <h4 class="heading4 heading4--tertiary">
                                Overview
                                <a v-if="false" class="heading-edit"></a>
                            </h4>

                            <ul class="overview-list">
                                <li v-if="startup.commonData.url_domain.length">
                                    <a :href="'http://' + startup.commonData.url_domain" target="_blank">
                                        <span class="d-flex align-items-center">
                                            <span class="overview-list__icon icon-globe"></span>
                                            {{ startup.commonData.url_domain }}
                                        </span>
                                    </a>
                                </li>
                                <li v-if="startup.commonData.total_raised > 0">
                                    <span class="d-flex align-items-center"><span class="overview-list__icon icon-funding"></span>$ {{stringHelper.formatNumber(startup.commonData.total_raised)}}</span>
                                </li>
                                <li v-if="startup.commonData.revenue_range"><span class="overview-list__icon icon-income"></span> {{ startup.commonData.revenue_range }} Annual Income</li>
                                <li v-if="startup.commonData.employees">
                                    <span class="d-flex align-items-center">
                                        <span class="overview-list__icon icon-users"></span>
                                        {{ startup.commonData.employees }} Employees
                                    </span>
                                </li>
                                <li>
                                    <span class="d-flex align-items-center">
                                        <span class="overview-list__icon icon-pin"></span>
                                        {{ getLocation(startup.commonData) }}
                                    </span>
                                </li>
                                <li><span class="overview-list__icon icon-sturtups"></span> {{ startup.commonData.stage }}</li>
                                <li v-if="startup.commonData.founded"><span class="overview-list__icon icon-founded"></span> Founded {{ startup.commonData.founded }}</li>
                            </ul>

                            <ul class="social-list">
                                <li v-if="startup.commonData.linkedin_url">
                                    <a :href="startup.commonData.linkedin_url">
                                        <span class="social-list__icon social-list__icon-ln"></span>
                                    </a>
                                </li>
                                <li v-if="startup.commonData.twitter_url">
                                    <a :href="startup.commonData.twitter_url">
                                        <span class="social-list__icon social-list__icon-twitter"></span>
                                    </a>
                                </li>
                                <li v-if="startup.commonData.facebook_url">
                                    <a :href="startup.commonData.facebook_url">
                                        <span class="social-list__icon social-list__icon-facebook"></span>
                                    </a>
                                </li>
                            </ul>

                            <template v-if="startup.commonData.categories.length">
                                <h4 class="heading4 heading4--tertiary">
                                    Categories
                                    <a v-if="false" class="heading-edit"></a>
                                </h4>

                                <div class="tags-list tags-list--light">
                                    <div v-for="category in startup.commonData.categories" :key="category.id" class="tags-list__tag">{{ category.name }}</div>
                                </div>
                            </template>

                            <p v-if="startup.commonData.crunch_status">
                                Data provided by Crunchbase <br>
                                Updated {{ dateHelper.decodeDate(startup.commonData.last_crunchbase_sync_date) }}
                            </p>
                            <p v-else>
                                Data provided by SwitchPitch
                            </p>
                            <!--                    <a class="link" href="#">More</a>-->
                            <template v-if="false && startup.commonData.website_keywords.length">
                                <div class="accordion mt-4">
                                    <header class="accordion__header" v-b-toggle.accordion-1 >
                                        <h4 class="accordion__title heading4 heading4--tertiary mb-0">Website Keywords</h4>
                                    </header>
                                    <b-collapse visible id="accordion-1" accordion="my-accordion" >
                                        <div class="tags-list tags-list--light">
                                            <span v-for="keyword in startup.commonData.website_keywords" :key="keyword">
                                                {{ keyword }},
                                            </span>
                                        </div>
                                    </b-collapse>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div class="content details-field">
                        <h4 class="heading4">Description</h4>

                        <p v-if="startup.commonData.description && startup.commonData.description.length">{{startup.commonData.description}}</p>
                        <p v-else>{{startup.commonData.short_description}}</p>

                        <div v-for="(section, sectionId) in startup.customFields" :key="sectionId">
                            <header class="details-field__header">
                                <h4 class="heading4">{{section.name}}</h4>

                                <div class="section-users ml-auto">
                                    <div class="section-users__images">
                                        <div v-for="(avatar, index) in stringHelper.getAvatarsForDisplay(section.permissions)" :key="index" class="section-users__images__item">
                                            <img :src="avatar" style="width: 30px;" alt=""/>
                                        </div>
                                    </div>

                                    <p>
                                        <a v-for="(item, index) in stringHelper.getPermissionNamesForDisplay(section.permissions)" :key="index">
                                            {{item}}
                                        </a>
                                    </p>
                                </div>

                            </header>


                            <table class="details-table">
                                <tr v-for="field in section.fields" :key="field.id">
                                    <td colspan="2" v-if="field.type == 'static_text'" class="pr-3">
                                        {{field.name}}
                                    </td>
                                    <td v-else>
                                        {{field.name}}
                                    </td>

                                    <td v-if="field.type != 'static_text'">
                                        <custom-field
                                            :disabled="true"
                                            :field="field"
                                            :value="startup.customData[field.id]"
                                            :editable="false"
                                            :forPDF="true"
                                        >
                                        </custom-field>
                                    </td>
                                </tr>

                                <tr v-if="section.is_default">
                                    <td>
                                        Tags
                                    </td>
                                    <td>
                                        <div class="tags-list tags-list--light">
                                            <div v-for="tag in startup.tags" :key="tag.id" class="tags-list__tag">
                                                {{ tag.name }}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <div v-if="typeof startup.answers !== 'undefined'">
                            <header class="details-field__header">
                                <h4 class="heading4">Submitted answers</h4>
                            </header>

                            <div class="details-table mt-2">
                                <div v-for="(answer, index) in startup.answers.before_break" :key="index">
                                    <div class="html2pdf__page-break" v-if="answer.break"></div>
                                    <div>
                                        <strong>{{answer.field.name}}</strong>
                                    </div>

                                    <div>
                                        <custom-field
                                            :disabled="true"
                                            :field="answer.field"
                                            :value="answer.value"
                                            :editable="false"
                                            :forPDF="true"
                                        >
                                        </custom-field>
                                    </div>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="details-table mt-2" style="padding: 15px" v-if="typeof startup.answers !== 'undefined' && startup.answers.after_break.length">
                    <div v-for="(answer, index) in startup.answers.after_break" :key="index">
                        <div>
                            <strong>{{answer.field.name}}</strong>
                        </div>

                        <div>
                            <custom-field
                                :disabled="true"
                                :field="answer.field"
                                :value="answer.value"
                                :editable="false"
                                :forPDF="true"
                            >
                            </custom-field>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
        </section>
    </vue-html2pdf>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf"
import customField from "@/components/customFields/CustomField"
import files from "@/services/files.service"
import { baseURL } from "@/axios";

export default {
    data() {
        return {
            baseURL
        }
    },
    components: {
        customField,
        VueHtml2pdf,
    },

    props: {
        startups: Array
    },

    methods: {
        generatePdf() {
            this.$refs.html2Pdf.generatePdf()
        },

        getLogoUrl(logoUrl) {
            if (logoUrl) {
                return logoUrl
            }
            else {
                return require('@/images/' + this.defaults.startupLogo)
            }
        },

        getLocation(commonData) {
            let str = []

            if (commonData.city) {
                str.push(commonData.city)
            }

            if (commonData.state) {
                str.push(commonData.state)
            }

            if (commonData.country) {
                str.push(commonData.country)
            }

            if (commonData.continent) {
                str.push(commonData.continent)
            }

            return str.join(', ')
        },

        download: async function({html2pdf, options, pdfContent}) {
            let html2PdfSetup = html2pdf().set(options).from(pdfContent)
            let pdfBlobUrl = await html2PdfSetup.output('bloburl')
            var res = await fetch(pdfBlobUrl);
            var pdfFile = await res.blob();

            let data = window.URL.createObjectURL(pdfFile)

            let fileNames = []
            this.startups.forEach(startup => {
                if (startup.commonData.logo_url) {
                    fileNames.push(startup.commonData.logo_url)
                }
            })

            files.deleteTempLogoFiles(fileNames)

            window.open(data, "_blank");
        },
    }
}
</script>

<style scoped>

</style>
